// Flow types automatically removed

import { Component } from 'react';
import validations from './validations';
import { Input } from 'dibs-elements/exports/Input';

class ValidatedInput extends Component {
    static defaultProps = {
        allowMultipleEmails: false,
        dataTn: 'validated-text-input',
        disabled: false,
        errorDataTn: 'validated-text-input-error',
        hasAnimatedPlaceholder: true,
        incorrectFieldErrorMessage: '',
        isRequiredField: false,
        label: '',
        placeholder: '',
        requiredFieldErrorMessage: 'Required Field',
        showSuccessIcon: true,
        validateOnMount: false,
        value: '',
        type: 'text',
    };

    constructor(props) {
        super(props);
        this.state = {
            hasValidText: false,
            errorMessage: '',
            value: this.props.value || '',
        };
    }

    componentDidMount() {
        if (this.props.validateOnMount) {
            this.validateInput(this.props.value);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { errorMessage } = this.state;
        const { canBeUpdatedByForm } = this.props;

        if (canBeUpdatedByForm && errorMessage !== nextProps.formUpdateErrorMessage) {
            this.setState({
                errorMessage: nextProps.formUpdateErrorMessage,
            });
        }
    }

    onBlur = e => {
        this.validateInput(this.state.value);

        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    };
    onChange = e => {
        this.setState({
            value: e.target.value,
        });

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };
    setErrorMessage = ({ isEmptyField = false } = {}) => {
        let errorMessage;

        if (isEmptyField) {
            // If input field is empty, but required
            errorMessage = this.props.requiredFieldErrorMessage;
        } else if (this.props.incorrectFieldErrorMessage) {
            // If input field is incorrect and there is a message provided
            errorMessage = this.props.incorrectFieldErrorMessage;
        } else {
            // If input field is incorrect and there is no message provided
            errorMessage = validations.errorMessages[this.props.validationType];
        }

        this.setState(
            {
                hasValidText: false,
                errorMessage,
            },
            () => {
                if (this.props.onError) {
                    this.props.onError();
                }
            }
        );
    };
    validateInput = value => {
        const { validationFunction } = this.props;

        if (value && value.length) {
            const isValid = validationFunction
                ? validationFunction(value)
                : validations[this.props.validationType](value);

            if (!isValid) {
                this.setErrorMessage();
            } else {
                this.setState(
                    {
                        hasValidText: this.props.showSuccessIcon,
                        errorMessage: '',
                    },
                    () => {
                        if (this.props.onSuccess) {
                            this.props.onSuccess();
                        }
                    }
                );
            }
        } else {
            if (this.props.onEmptyField) {
                this.props.onEmptyField();
            }

            if (this.props.isRequiredField) {
                this.setErrorMessage({
                    isEmptyField: true,
                });
            } else {
                this.setState({
                    hasValidText: false,
                    errorMessage: '',
                });
            }
        }
    };

    render() {
        const { placeholder, maskForPrivacy } = this.props;
        return (
            <Input
                disabled={this.props.disabled}
                dataTn={this.props.dataTn || ''}
                errorDataTn={this.props.errorDataTn}
                errorMessage={this.state.errorMessage}
                hasAnimatedPlaceholder={this.props.hasAnimatedPlaceholder && !!placeholder}
                hasValidText={this.state.hasValidText}
                label={this.props.label}
                onBlur={this.onBlur}
                onChange={this.onChange}
                placeholder={placeholder}
                value={this.state.value}
                maskForPrivacy={maskForPrivacy}
                type={this.props.type}
            />
        );
    }
}

export default ValidatedInput;
